import React, { useEffect, useState } from 'react';
import {Button, Row, Col, Modal, Spin, notification, Select} from 'antd';
import { formHelper } from "../../../helpers";
import InputField from "../../input-field";
import {roleService, distributionCenterService, userServices, consignorService} from "../../../services";
import SelectField from "../../select-field";
import '../modals.css';
import i18n from '../../../i18n';

const defaultUserData = {
    fio: '',
    login: '',
    countryId: 1,
    password: null,
    email: '',
    phone: '',
    role: null,
    consignorId: null,
    distributionsCentersIds: [],
};

export default function ModalCreateStaffUser({ isShow, onCloseModal }) {

    const [loadingContentModal, setLoadingContentModal] = useState(false);
    const [needUpdateContent, setNeedUpdateContent] = useState(false);

    const [listStaffRoles, setListStaffRoles] = useState([]);
    const [listDistCenters, setListDistCenters] = useState([]);

    const [userData, setUserData] = useState(defaultUserData);

    const [fieldsErrors, setFieldsErrors] = useState(null);

    const [countryList, setCountryList] = useState([
        {
            Id: 1,
            Name: i18n.t('constants.countries.1')
        },
        {
            Id: 3,
            Name: i18n.t('constants.countries.2')
        }
    ]);

    const [consignorsList, setConsignorsList] = useState([]);

    const getFieldErrors = (nameField) => formHelper.getFieldErrors(nameField, fieldsErrors);

    let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent" };

    useEffect(() => {
        if (isShow && !loadingContentModal) {
            setLoadingContentModal(true);
            setNeedUpdateContent(true);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow) {
            consignorService
                .getConsignorsList()
                .then((resp) => {
                    setConsignorsList(resp);
                })
                .catch((err) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getConsignorsList'),
                        description: err,
                    });
                });
        }
    }, [isShow]);

    useEffect(() => {
        if (userData.consignorId) {
            setUserData({...userData, distributionsCentersIds: []});

            distributionCenterService.getCompanies(null, null, userData.consignorId)
                .then((response) => {
                    setNeedUpdateContent(false);
                    setLoadingContentModal(false);

                    const distCentersData = response.map((distCenterInfo) => {
                        return {
                            Id: distCenterInfo.Id,
                            Name: distCenterInfo.Name,
                        }
                    });

                    setListDistCenters(distCentersData);
                })
                .catch((error) => {
                    setNeedUpdateContent(false);
                    setLoadingContentModal(false);
                    notification.error({
                        message: i18n.t('components.notification.titles.getCompanies2'),
                        description: error,
                    });
                });
        }
    }, [userData.consignorId]);

    if (needUpdateContent) {

        roleService.getRoles()
            .then((response) => {
                setNeedUpdateContent(false);
                setLoadingContentModal(false);

                const staffRolesData = response.map((roleData) => {
                    return {
                        Id: roleData.Name,
                        Name: roleData.Description,
                    }
                });

                setListStaffRoles(staffRolesData);
            })
            .catch((error) => {
                setNeedUpdateContent(false);
                setLoadingContentModal(false);
                notification.error({
                    message: i18n.t('components.notification.titles.getRoles'),
                    description: error,
                });
            });
    }


    const onClickCreate = () => {
        setLoadingContentModal(true);


        userServices
            .createStaffUser(userData.fio, userData.login, userData.password, userData.email, userData.phone, userData.role, userData.distributionsCentersIds, userData.consignorId, userData.countryId)
            .then((response) => {
                setLoadingContentModal(false);

                if (response.status === 'success') {

                    notification.success({
                        message: i18n.t('components.notification.titles.createStaffUser2'),
                        description: response.message,
                    });

                    setUserData(defaultUserData);
                    onCloseModal();

                } else if (response.status === 'error') {

                    setFieldsErrors(response.errors);
                }
            })
            .catch((error) => {
                setLoadingContentModal(false);
                notification.error({
                    message: i18n.t('components.notification.titles.createStaffUser2'),
                    description: error,
                });
            })
    };

    return (
        <Modal
            title={<span>{i18n.t('modals.userModalCreateStaffUser.title')}</span>}
            cancelText={i18n.t('main.buttons.close')}
            style={{ top: 20, minWidth: "700px" }}
            align={null}
            visible={isShow}
            onCancel={onCloseModal}
            footer={[
                <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" onClick={onClickCreate}>{i18n.t('main.buttons.create')}</Button>,
            ]}
        >
            <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
                <Row gutter={[16, 24]} >
                    <Col span={24} >
                        <InputField name="fio" label={i18n.t('modals.userModalCreateStaffUser.fields.fio.title')}
                            value={userData.fio}
                            setValue={(fio) => setUserData({ ...userData, fio: fio })}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <SelectField
                            title={i18n.t('modals.userModalCreateStaffUser.fields.country.title')}
                            name="country"
                            selectedValue={userData.countryId}
                            values={countryList}
                            getErrors={getFieldErrors}
                            onChange={(value) => {
                                setUserData({ ...userData, countryId: value })
                            }}
                            placeholder={i18n.t('modals.userModalCreateStaffUser.fields.country.placeholder')}
                            notFoundText={i18n.t('modals.userModalCreateStaffUser.fields.country.notFoundText')}
                            style={{ width: "100%" }}
                        />
                    </Col>
                </Row>
                <Row gutter={[16, 24]} >
                    <Col lg={12} md={24} sm={24} xs={24} >
                        <InputField style={{width: "86% !important"}} name="login" label={i18n.t('modals.userModalCreateStaffUser.fields.login.title')}
                            value={userData.login}
                            setValue={(value) => setUserData({ ...userData, login: value })}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24} >
                        <InputField name="password" label={i18n.t('modals.userModalCreateStaffUser.fields.password.title')}
                            value={userData.password}
                            setValue={(value) => setUserData({ ...userData, password: value })}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                </Row>
                <Row gutter={[16, 24]} >
                    <Col lg={12} md={24} sm={24} xs={24} >
                        <InputField name="email" label={i18n.t('modals.userModalCreateStaffUser.fields.email.title')}
                            value={userData.email}
                            setValue={(value) => setUserData({ ...userData, email: value })}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24} >
                        <InputField name="phone" label={i18n.t('modals.userModalCreateStaffUser.fields.phone.title')}
                            value={userData.phone}
                            setValue={(value) => setUserData({ ...userData, phone: value })}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                </Row>
                <Row gutter={[16, 24]} >
                    <Col span={24} >
                        <SelectField
                            title={i18n.t('modals.userModalCreateStaffUser.fields.role.title')}
                            name="role"
                            selectedValue={userData.role}
                            values={listStaffRoles}
                            onChange={(value) => {
                                setUserData({ ...userData, role: value });
                            }}
                            getErrors={getFieldErrors}
                            placeholder={i18n.t('modals.userModalCreateStaffUser.fields.role.placeholder')}
                            notFoundText={i18n.t('modals.userModalCreateStaffUser.fields.role.notFoundText')}
                            style={{ width: "100%" }}
                        />
                    </Col>
                </Row>

                <Row gutter={[16, 24]} >
                    <Col span={24} >
                        <SelectField
                            title={i18n.t('modals.userModalCreateStaffUser.fields.consignorId.title')}
                            name="consignorId"
                            selectedValue={userData.consignorId}
                            values={consignorsList}
                            onChange={(value) => {
                                setUserData({ ...userData, consignorId: value });
                            }}
                            getErrors={getFieldErrors}
                            placeholder={i18n.t('modals.userModalCreateStaffUser.fields.consignorId.placeholder')}
                            notFoundText={i18n.t('modals.userModalCreateStaffUser.fields.consignorId.notFoundText')}
                            style={{ width: "100%" }}
                        />
                    </Col>
                </Row>
                <Row gutter={[16, 24]} >
                    <Col span={24} >
                        <SelectField
                            mode="multiple"
                            title={i18n.t('modals.userModalCreateStaffUser.fields.distributionsCentersIds.title')}
                            name="distributionsCentersIds"
                            selectedValue={userData.distributionsCentersIds}
                            values={listDistCenters}
                            onChange={(value) => {
                                setUserData({ ...userData, distributionsCentersIds: value });
                            }}
                            getErrors={getFieldErrors}
                            placeholder={i18n.t('modals.userModalCreateStaffUser.fields.distributionsCentersIds.placeholder')}
                            notFoundText={i18n.t('modals.userModalCreateStaffUser.fields.distributionsCentersIds.notFoundText')}
                            style={{ width: "100%" }}
                        />
                    </Col>
                </Row>
            </Spin>
        </Modal>
    );
}
